<div
  class="text-ss-brown bg-white pt-16 px-8 lg:px-20 flex flex-col items-center"
  [ssDirectus]="{
    collection: 'duoSelector',
    item: duoSelectorData.id,
    fields: ['title', 'leftOption', 'rightOption'],
  }"
>
  <div [innerHTML]="duoSelectorData.title | safe: 'html'"></div>
  <ss-duo-selector-toggle
    [data]="duoSelectorToggleData"
    (valueChange)="onToggleChange($event)"
    class="flex w-full max-w-[419px]"
  ></ss-duo-selector-toggle>
  @if (selectedOption() === 'left') {
    <ss-www-text-block
      [textBlockData]="duoSelectorData.leftOption.optionContent"
      [lastBlock]="false"
    ></ss-www-text-block>
  }
  @if (selectedOption() === 'right') {
    <ss-www-text-block
      [textBlockData]="duoSelectorData.rightOption.optionContent"
      [lastBlock]="false"
    ></ss-www-text-block>
  }
</div>
